// Berry-style Main Content Layout
// Adjusts width and margin based on drawer state

import { styled } from '@mui/material/styles';
import drawerConfig from '../drawerConfig';

const drawerWidth = drawerConfig.width;
const miniDrawerWidth = drawerConfig.miniWidth;

// Berry-style main content with negative margin approach
const MainContent = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'hasUser'
})(({ theme, open, hasUser }) => ({
  // Flex chain: must be a flex column so PageShell children can drive height.
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0, // critical — allows children to shrink below natural size
  padding: theme.spacing(3),
  marginTop: 64, // Clear the fixed header

  // Mobile — no permanent drawer, so always full width with no margin adjustment.
  width: '100%',
  marginLeft: 0,

  // md+ — permanent mini drawer exists, apply width + margin calculations.
  [theme.breakpoints.up('md')]: {
    width: (hasUser && drawerConfig.enabled) ? `calc(100% - ${drawerWidth}px)` : '100%',
    ...(!open && hasUser && drawerConfig.enabled && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -(drawerWidth - miniDrawerWidth),
    }),
    ...(open && hasUser && drawerConfig.enabled && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  },
}));

export default MainContent;
